import React from "react";
import { useParams } from "react-router-dom";
import OrderPicking from "./index.js";
import { CHEFS_FARM, GROWY } from "../../../../constants/CompanyConstants";

const OrderPickingWrapper = () => {
  const { companyType } = useParams();

  const getCompanyConfig = (type) => {
    switch (type) {
      case "chefs-farm":
        return {
          companyFilter: CHEFS_FARM,
          title: "orderpicking_chefs_farm",
          logoSrc: "/img/logo.png",
          logoAlt: "Chef's Farm logo",
        };
      case "growy":
        return {
          companyFilter: GROWY,
          title: "orderpicking_growy",
          logoSrc: "/img/logo-growy.png",
          logoAlt: "Growy logo",
        };
      default:
        return {
          companyFilter: "All",
          title: "orderpicking_all",
          logoSrc: "/img/logo.png",
          logoAlt: "Logo",
        };
    }
  };

  const config = getCompanyConfig(companyType);

  return <OrderPicking {...config} />;
};

export default OrderPickingWrapper;
